import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { validateProducts } from 'lib/functions/utils';
import {
  hasAnyPermissions,
  validateCompanyTypes,
  validatePermissions,
} from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import ConfirmingRequests from './Confirming';
import CreditLineRequested from './CreditLine/components/Recieved';
import CreditsRequested from './CreditsRequests/components/Recieved';
import Extensions from './Extensions';
import FactoringRequestsRecieved from './Factoring/components/Recieved';
import FactoringRequestsSent from './Factoring/components/Sent';
import PaymentRequestPassives from './PaymentRequestPassives';
import CessionsManagement from './ReversedCession';
import SGR from './SGR';

const Financing: React.FC = () => {
  const { subPage } = useParams<{ subPage: string }>();

  const [loading, setLoading] = useState(true);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [startValue, setStartValue] = useState(0);
  const navigate = useNavigate();

  const handleNavigation = (index: number) => {
    navigate(`/finance/financing/${companyTabs[index].path}`);
  };

  const fetchRelations = async () => {
    setLoading(true);
    const newCompanyTabs = [];
    if (validateCompanyTypes(user, 'Accountant')) {
      if (validatePermissions(user, 'financing_factoring_receive'))
        newCompanyTabs.push({
          label: 'Factoring',
          component: <FactoringRequestsSent />,
          path: 'factoring',
        });
    }
    if (validateCompanyTypes(user, 'FactoringQuoting')) {
      if (validateCompanyTypes(user, 'FinancingHub')) {
        if (hasAnyPermissions(user, ['financing_creditLine_receive']))
          newCompanyTabs.push({
            label: 'Líneas de crédito ',
            component: <CreditLineRequested />,
            path: 'creditLine',
          });
        if (validateProducts(user, ['factoring'])) {
          if (validatePermissions(user, 'financing_factoring_receive'))
            newCompanyTabs.push({
              label: 'Factoring ',
              component: <FactoringRequestsRecieved />,
              path: 'factoring',
            });
        }
        if (validateProducts(user, ['confirming'])) {
          if (validatePermissions(user, 'financing_confirming_receive'))
            newCompanyTabs.push({
              label: 'Confirming',
              component: <ConfirmingRequests />,
              path: 'confirming',
            });
        }
        if (validateProducts(user, ['credit'])) {
          if (validatePermissions(user, 'financing_credit_receive'))
            newCompanyTabs.push({
              label: 'Créditos ',
              component: <CreditsRequested />,
              path: 'credits',
            });
        }
        if (validateProducts(user, ['sgr'])) {
          if (validatePermissions(user, 'financing_sgr_receive'))
            newCompanyTabs.push({
              label: 'Garantías',
              component: <SGR />,
              path: 'sgr',
            });
        }
        if (
          validatePermissions(user, 'financing_payment_request_passive_read')
        ) {
          newCompanyTabs.push({
            label: 'Dev. Pasivos',
            component: <PaymentRequestPassives />,
            path: 'paymentRequestPassive',
          });
        }
        if (validatePermissions(user, 'financing_extension_view'))
          newCompanyTabs.push({
            label: 'Prórrogas',
            component: <Extensions />,
            path: 'extensions',
            disabled: !validatePermissions(user, 'financing_extension_view'),
          });
        if (validateProducts(user, ['factoring', 'confirming'])) {
          if (validatePermissions(user, 'financing_reversed_cession_view'))
            newCompanyTabs.push({
              label: 'Reversar',
              component: <CessionsManagement />,
              path: 'reversed',
            });
        }
      } else {
        if (validatePermissions(user, 'financing_factoring_receive'))
          newCompanyTabs.push({
            label: 'Factoring ',
            component: <FactoringRequestsRecieved />,
            path: 'factoring',
            disabled: !validatePermissions(user, 'financing_factoring_receive'),
          });
      }
    }
    const startingIndex = newCompanyTabs.findIndex(
      (x: any) => x.path === subPage,
    );
    setCompanyTabs(newCompanyTabs);
    setStartValue(startingIndex > 0 ? startingIndex : 0);
    setLoading(false);
  };

  useEffect(() => {
    void fetchRelations();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        startValue={startValue}
        tabs={companyTabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default Financing;
